import { ApiError } from './api'

// Backend responses are fully localized server-side (via `Accept-Language`) —
// prefer the message it sends over a generic frontend string whenever one is
// present.
export const getErrorToastMessage = (error: unknown, fallback: string): string =>
  error instanceof ApiError && error.serverMessage ? error.serverMessage : fallback

export const getCreatedToastMessage = (
  result: { status: number; message?: string },
  fallback: string,
): string => (result.status === 201 && result.message ? result.message : fallback)
